export default "__VITE_ASSET__0b95c9c5__"